export const useErrorLogger = () => {
  const getClientCorrelationId = () => {
    if (!import.meta.client) return undefined
    const storageKey = 'idtech-client-correlation-id'
    const existing = window.sessionStorage.getItem(storageKey)
    if (existing) return existing

    const fallback = `${Date.now()}-${Math.random().toString(16).slice(2, 10)}`
    const generated =
      typeof window.crypto?.randomUUID === 'function' ? window.crypto.randomUUID() : fallback
    window.sessionStorage.setItem(storageKey, generated)
    return generated
  }

  const reportToServer = (payload) => {
    $fetch('/api/log-error', {
      method: 'POST',
      body: payload
    }).catch(() => {})
  }

  const inferErrorType = (errorMessage) => {
    if (!errorMessage) return 'unknown'
    if (errorMessage.includes('dynamically imported module')) return 'dynamic_import_failure'
    if (errorMessage.includes('module script failed')) return 'module_script_failure'
    if (errorMessage.includes('Unable to preload CSS')) return 'css_preload_failure'
    return 'application_error'
  }

  const logError = (error, additionalContext = {}) => {
    const runtimeConfig = useRuntimeConfig()
    const statusCode =
      typeof error?.statusCode === 'number' && Number.isInteger(error.statusCode)
        ? error.statusCode
        : undefined
    const message = error?.message || 'Unknown error'

    const payload = {
      source: 'nuxt-fe',
      service: 'nuxt',
      env: runtimeConfig.public.nuxtEnvironment,
      release: runtimeConfig.public.nuxtEnvironment,
      statusCode,
      message,
      stack: error?.stack,
      url: import.meta.client ? window.location.href : '',
      errorType: inferErrorType(message),
      requestId:
        typeof additionalContext.requestId === 'string' ? additionalContext.requestId : undefined,
      clientCorrelationId: getClientCorrelationId(),
      timestamp: new Date().toISOString(),
      ...additionalContext
    }

    reportToServer(payload)
  }

  return { logError }
}
